import React from 'react';
import { StyledEngineProvider } from '@mui/material/styles';
import GlobalStyles from '@mui/material/GlobalStyles';
import ThemeProvider from './components/ThemeProvider';
import { ApiProvider } from '@reduxjs/toolkit/query/react';
import api from 'services/api';
import { BrowserRouter } from 'react-router';
import Router from './Router';
import Notification from 'components/Notification';
import Layout from 'Layout';

const App = () => {
  return (
    <React.StrictMode>
      <StyledEngineProvider enableCssLayer>
        <GlobalStyles styles="@layer theme, base, mui, components, utilities;" />
        <ThemeProvider>
          <ApiProvider api={api}>
            <BrowserRouter>
              <Layout>
                <Router />
              </Layout>
              <Notification />
            </BrowserRouter>
          </ApiProvider>
        </ThemeProvider>
      </StyledEngineProvider>
    </React.StrictMode>
  );
};

export default App;
